import { Card, Form } from "react-bootstrap";
import CustomButton from "../../components/CustomButton/CustomButton";
import { useEffect, useRef, useState } from "react";
import WebService from "../../utility/WebService";
import { PencilFill, TrashFill, EyeFill } from "react-bootstrap-icons";
import DeleteModal from "../../components/DeleteModal/DeleteModal";
import StatusConfirmModal from "../../components/StatusConfirmModal/StatusConfirmModal";
import CustomTableSortable from "../../components/CustomTable/CustomTableSortable";
import HelperService from "../../utility/HelperService";
import AddAdminUser from "./AddCustomer";
import { toast } from "react-toastify";
import ViewCustomer from "./ViewCustomer";
import Select from "react-select";

export interface UserInterface {
  _id: number;
  fullName: string;
  email: string;
  username: string;
  password: string;
  user_type: "ADMIN" | "USER";
  organization?: string;
  otp?: string | null;
  phone?: string | null;
  temp_otp?: string | null;
  image?: string | null;
  type?: string | null;
  organization_type?: string | null;
  isVerified: string; // 'Y' or 'N'
  verificationToken?: string;
  social_type?: string | null;
  socialid?: string | null;
  status: AdminUserStatusEnum;

  createdAt?: Date | string;
  updatedAt?: Date | string;
  lastVisitedAt?: Date | string;

  organization_name?: string;
  website?: string;
  category?: string;
  office_email?: string;
  office_phone?: string;
  gst_number?: string;
  address?: string;
  pincode?: string;

  country?: string; // Country ObjectId
  state?: string; // State ObjectId
  city?: string; // City ObjectId

  logo?: string | null;
}

export enum AdminUserStatusEnum {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
  DELETED = "DELETED",
}

const columns = [
  // {
  //   id: "userType",
  //   label: "User Type",
  //   minWidth: 170,
  //   sortable: true,
  // },
  {
    id: "fullName",
    label: "Name",
    minWidth: 170,
    sortable: true,
  },
  {
    id: "username",
    label: "User Name",
    minWidth: 170,
    sortable: true,
  },
  {
    id: "email",
    label: "Email",
    minWidth: 170,
    sortable: true,
  },
  {
    id: "organization_name",
    label: "Organization Name",
    minWidth: 170,
    sortable: true,
  },
  {
    id: "status",
    label: "Status",
    minWidth: 170,
    sortable: true,
  },
  {
    id: "user_type",
    label: "User Group",
    minWidth: 170,
    sortable: true,
  },
  // {
  //     id: "phone",
  //     label: "Contact",
  //     minWidth: 170,
  //     sortable: true,
  // },
  {
    id: "createdAt",
    label: "Created Date",
    minWidth: 170,
    sortable: true,
  },
  {
    id: "lastVisitedAt",
    label: "Last visited Date",
    minWidth: 170,
    sortable: true,
  },
  {
    id: "action",
    label: "Action",
    minWidth: 100,
    align: "center" as const,
  },
];

const Customer = () => {
  const [showAdminBlade, setShowAdminBlade] = useState(false);
  const [leadershipCouncils, setLeadershipCouncils] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [userToDelete, setUserToDelete] = useState<string | null>(null);
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const [search, setSearch] = useState("");
  const searchRef = useRef<string>("");
  const [sortField, setSortField] = useState<string>("createdAt");
  const [sortOrder, setSortOrder] = useState<"asc" | "desc">("desc");
  const [uiSortField, setUiSortField] = useState<string>("createdAtFormatted");
  const [loading, setLoading] = useState<boolean>(false);
  const sortFieldMap: Record<string, string> = {
    createdAtFormatted: "createdAt",
    createdAt: "createdAt",
    fullName: "fullName",
    username: "username",
    email: "email",
    organization_name: "organization_name",
    status: "status",
    user_type: "type",
    lastVisitedAt: "lastVisitedAt",
  };
  const [userObject, setUserObject] = useState<UserInterface | null>(null);
  const [showCustomerView, setShowCustomerView] = useState(false);
  const [organizationType, setOrganizationType] = useState<string>("");
  const [pagePermission, setPagePermission] = useState({
    canView: false,
    canAdd: false,
    canEdit: false,
    canDelete: false,
  });
  const [statusFilter, setStatusFilter] = useState<string>("");
  const ORGANIZATION_TYPES = [
    { label: "All", value: "" },
    { label: "Individual", value: "INDIVIDUAL" },
    { label: "Organization", value: "ORGANIZATION" },
  ];

  const [dateFilterType, setDateFilterType] = useState<"CREATED" | "VISITED">("CREATED");
  const [dateFrom, setDateFrom] = useState<string>("");
  const [dateTo, setDateTo] = useState<string>("");

  const [organizationList, setOrganizationList] = useState<any[]>([]);
  const [selectedOrganization, setSelectedOrganization] = useState<string>("");

  const organizationOptions = organizationList.map((org) => ({
    value: org._id,
    label: org.name,
  }));

  const [statusModalTitle, setStatusModalTitle] = useState("");
  const [statusModalMessage, setStatusModalMessage] = useState("");

  const [showStatusModal, setShowStatusModal] = useState(false);
  const [statusUserId, setStatusUserId] = useState<number | null>(null);
  const [nextStatus, setNextStatus] =
    useState<AdminUserStatusEnum | null>(null);

  const getOrganizationList = () => {
    WebService.getAPI({
      action: "organizations/list-all",
    })
      .then((res: any) => {
        setOrganizationList(res?.data || []);
      })
      .catch(() => {
        toast.error("Failed to load organizations");
      });
  };

  const getUserTypeLabel = (type?: string | null, organization?: { type?: string } | null) => {
    if (!type) return "-";

    // 1️⃣ Organization nahi hai ya type ORGANIZATION nahi hai → kuch bhi mat dikhao
    if (!organization || organization.type !== "ORGANIZATION") {
      return "-";
    }
    if (type === "company manager" || type === "ORG-ADMIN") return "Company Manager";
    if (type !== "company manager" && type !== "ORG-ADMIN") return "Team Member";

    return type.replace(/_/g, " ");
  };

  useEffect(() => {
    getOrganizationList();
  }, []);

  useEffect(() => {
    getUserList(searchRef.current);
  }, [currentPage, organizationType, statusFilter, dateFilterType, dateFrom, dateTo, selectedOrganization, sortField, sortOrder]);
  const toTitleCase = (str = "") =>
    str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
  const getStatusTag = (status?: string, isVerified?: string) => {
    if (!status) return "-";

    // 1️⃣ ACTIVE + VERIFIED
    if (status === "ACTIVE" && isVerified === "Y") {
      return (
        <span style={{ color: "#16a34a", fontWeight: 600 }}>
          Active
        </span>
      );
    }

    // 2️⃣ ACTIVE + NOT VERIFIED
    if (status === "ACTIVE" && isVerified === "N") {
      return (
        <span style={{ color: "#f59e0b", fontWeight: 600 }}>
          Not Verified
        </span>
      );
    }

    // 3️⃣ INACTIVE (verified or not)
    if (status === "INACTIVE") {
      return (
        <span style={{ color: "#dc2626", fontWeight: 600 }}>
          Disabled
        </span>
      );
    }

    // fallback
    return (
      <span style={{ color: "#6b7280", fontWeight: 600 }}>
        {status}
      </span>
    );
  };

  const getUserList = (keyword: string = "") => {
    setLoading(true);
    const params = new URLSearchParams();
    params.append("page", currentPage.toString());
    params.append("limit", itemsPerPage.toString());

    // Keyword search
    if (keyword.trim()) {
      params.append("keyword", keyword.trim());
    }

    params.append("organization_type", organizationType);

    if (statusFilter) {
      params.append("status", statusFilter);
    }

    if (selectedOrganization) {
      params.append("organization", selectedOrganization);
    }


    if (dateFrom) params.append("dateFrom", dateFrom);
    if (dateTo) params.append("dateTo", dateTo);
    params.append("dateType", dateFilterType); // CREATED | VISITED

    // Sorting
    params.append("sortField", sortField);
    params.append("sortOrder", sortOrder);

    WebService.getAPI({
      action: `users/user-list?${params.toString()}`,
    })
      .then((res: any) => {
        const perm = res?.data?.permissions || {};

        setPagePermission({
          canView: perm.canView,
          canAdd: perm.canAdd,
          canEdit: perm.canEdit,
          canDelete: perm.canDelete,
        });
        const formattedRows = res?.data?.data.map((item: any) => {
          return {
            ...item,

            // userType: toTitleCase(item.organization_type) || "-",

            fullName: item.fullName || "-",
            username: item.username || "-",
            email: item.email || "-",
            organization_name:
              item.organization?.type == "ORGANIZATION"
                ? item.organization?.name
                : "-",
            user_type: getUserTypeLabel(item.type, item.organization),
            status: getStatusTag(item.status, item.isVerified),
            // phone: item.phone || "-",
            createdAt: HelperService.getFormatedDate(item.createdAt),
            lastVisitedAt: HelperService.getFormatedDate(item.lastVisitedAt),
            action: (
              <div>
                {" "}
                {perm.canEdit && (
                  <PencilFill
                    className="me-3 cursor-pointer"
                    onClick={() => {
                      setShowAdminBlade(true);
                      setUserObject(item);
                    }}
                    title="Edit"
                  />
                )}
                {perm.canDelete && (
                  <TrashFill
                    color="#DC143C"
                    className="cursor-pointer me-3"
                    onClick={() => handleDeleteEvent(item._id)}
                    title="Delete"
                  />
                )}
                {perm.canEdit && (
                  <EyeFill
                    className="me-3 cursor-pointer"
                    size={18}
                    onClick={() => {
                      setShowCustomerView(true);
                      setUserObject(item);
                    }}
                    title="View"
                  />
                )}
                {/* Status Action */}
                {perm.canEdit && (
                  <>
                    {item.status === AdminUserStatusEnum.ACTIVE ? (
                      item.isVerified === "N" ? (
                        // 🔥 VERIFY USER
                        <span
                          title="Verify User"
                          className="cursor-pointer"
                          style={{ color: "#f59e0b", fontSize: "18px" }}
                          onClick={() => {
                            setStatusUserId(item._id);
                            setShowStatusModal(true);

                            setStatusModalTitle("Verify User");
                            setStatusModalMessage("Are you sure you want to verify this user?");
                          }}
                        >
                          ⚠
                        </span>
                      ) : (
                        // 🚫 DEACTIVATE USER
                        <span
                          title="Deactivate"
                          className="cursor-pointer"
                          style={{ color: "#dc2626", fontSize: "18px" }}
                          onClick={() => {
                            setStatusUserId(item._id);
                            setShowStatusModal(true);

                            setStatusModalTitle("Deactivate User");
                            setStatusModalMessage("Are you sure you want to deactivate this user?");
                          }}
                        >
                          ⛔
                        </span>
                      )
                    ) : (
                      // ✅ ACTIVATE USER
                      <span
                        title="Activate"
                        className="cursor-pointer"
                        style={{ color: "#16a34a", fontSize: "18px" }}
                        onClick={() => {
                          setStatusUserId(item._id);
                          setShowStatusModal(true);

                          setStatusModalTitle("Activate User");
                          setStatusModalMessage("Are you sure you want to activate this user?");
                        }}
                      >
                        ✔
                      </span>
                    )}
                  </>
                )}
              </div>
            ),
          };
        });
        setLeadershipCouncils(formattedRows);
        setTotalCount(res?.data?.pagination?.total || 0);
      })
      .catch((err: any) => {
        console.error("Error fetching admin users:", err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleExport = () => {
    const params = new URLSearchParams();

    if (searchRef.current.trim()) {
      params.append("keyword", searchRef.current.trim());
    }

    if (statusFilter) params.append("status", statusFilter);

    if (organizationType) params.append("organization_type", organizationType);

    if (dateFrom) params.append("dateFrom", dateFrom);
    if (dateTo) params.append("dateTo", dateTo);

    if (selectedOrganization) {
      params.append("organization", selectedOrganization);
    }

    params.append("dateType", dateFilterType); // CREATED | VISITED

    // optional: sorting
    params.append("sortField", sortField);
    params.append("sortOrder", sortOrder);
    WebService.getAPI({
      action: `users/export-users?${params.toString()}`,
    })
      .then((res: any) => {
        const blob = new Blob([res], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "users_export.csv";
        document.body.appendChild(a);
        a.click();
        a.remove();

        toast.success("Exported successfully!");
      })
      .catch(() => {
        toast.error("Failed to export!");
      });
  };

  const handleDeleteEvent = (Id: string) => {
    setUserToDelete(Id);
    setShowDeleteModal(true);
  };

  const handleDeactivateUser = (userId: number) => {
    if (!window.confirm("Are you sure you want to deactivate this user?")) return;

    WebService.putAPI({
      action: `users/active-inactive-user/${userId}`,
      body: { status: AdminUserStatusEnum.INACTIVE },
    })
      .then(() => {
        toast.success("User deactivated successfully");
        getUserList(searchRef.current);
      })
      .catch(() => toast.error("Failed to deactivate user"));
  };

  const handleActivateUser = (userId: number) => {
    WebService.putAPI({
      action: `users/active-inactive-user/${userId}`,
      body: { status: AdminUserStatusEnum.ACTIVE },
    })
      .then(() => {
        toast.success("User activated successfully");
        getUserList(searchRef.current);
      })
      .catch(() => toast.error("Failed to activate user"));
  };

  return (
    <>
      <AddAdminUser
        show={showAdminBlade}
        handleClose={() => {
          setShowAdminBlade(false);
          getUserList(searchRef.current);
          setUserObject(null);
        }}
        data={userObject}
      />
      <DeleteModal
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        onDelete={() => {
          if (userToDelete) {
            WebService.deleteAPI({
              action: `users/delete-user/${userToDelete}`,
            }).then(() => {
              setShowDeleteModal(false);
              toast.success("User deleted successfully.");
              getUserList(searchRef.current);
            });
          }
        }}
        message="Are you sure you want to delete ?"
      />
      <StatusConfirmModal
        show={showStatusModal}
        onHide={() => setShowStatusModal(false)}
        title={statusModalTitle}
        message={statusModalMessage}
        onConfirm={() => {
          if (!statusUserId) return;

          WebService.putAPI({
            action: `users/active-inactive-user/${statusUserId}`,
            body: {},
          })
            .then((res: any) => {
              toast.success(res?.message || "Updated successfully");
              setShowStatusModal(false);
              getUserList(searchRef.current);
            })
            .catch(() => toast.error("Failed to update user status"));
        }}
      />
      <ViewCustomer
        show={showCustomerView}
        handleClose={() => {
          setShowCustomerView(false);
          getUserList(searchRef.current);
          setUserObject(null);
        }}
        data={userObject}
      />
      <div className="events-main">
        <Card className="event-card">
          <div className="d-flex justify-content-between">
            <div className="page-title">Users</div>

            <div className="btn-group">
              {pagePermission.canAdd && (
                <CustomButton
                  isLoading={false}
                  label="Add User"
                  onClick={() => {
                    setShowAdminBlade(true);
                    setUserObject(null);
                  }}
                  style={{ width: 120 }}
                />
              )}

              {pagePermission.canView && (
              <CustomButton
                isLoading={false}
                label="Export"
                onClick={handleExport}
                style={{ width: 120, marginLeft: 10 }}
              />
              )}
            </div>
          </div>
          <div className="row">
            <div className="col-md-3">
              <Form.Label className="label">Search</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter name or email or contact"
                value={search}
                onChange={(e) => {
                  const value = e.target.value;
                  searchRef.current = value;
                  setSearch(value);
                  setCurrentPage(1);
                  getUserList(searchRef.current);
                }}
              />
            </div>
            <div className="col-md-3">
              <Form.Label className="label">Organization</Form.Label>
              <Select
                options={organizationOptions}
                isClearable
                placeholder="Search organization..."
                value={
                  organizationOptions.find(
                    (opt) => opt.value === selectedOrganization
                  ) || null
                }
                onChange={(selected) => {
                  setSelectedOrganization(selected ? selected.value : "");
                  setCurrentPage(1);
                }}
              />
            </div>
            <div className="col-md-3">
              <Form.Label className="label">Status</Form.Label>
              <Form.Select
                value={statusFilter}
                onChange={(e) => {
                  setStatusFilter(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="">All</option>
                <option value="ACTIVE_VERIFIED">Active</option>
                <option value="ACTIVE_NOT_VERIFIED">Not Verified</option>
                <option value="INACTIVE">Disabled</option>
              </Form.Select>
            </div>
          </div>
          <div className="row mt-3">
            {/* Date Type */}
            <div className="col-md-3">
              <Form.Label className="label">Date Type</Form.Label>
              <Form.Select
                value={dateFilterType}
                onChange={(e) => {
                  setDateFilterType(e.target.value as "CREATED" | "VISITED");
                  setCurrentPage(1);
                }}
              >
                <option value="CREATED">Created Date</option>
                <option value="VISITED">Last Visited Date</option>
              </Form.Select>
            </div>

            {/* From Date */}
            <div className="col-md-3">
              <Form.Label className="label">From</Form.Label>
              <Form.Control
                type="date"
                value={dateFrom}
                onChange={(e) => {
                  setDateFrom(e.target.value);
                  setCurrentPage(1);
                }}
              />
            </div>

            {/* To Date */}
            <div className="col-md-3">
              <Form.Label className="label">To</Form.Label>
              <Form.Control
                type="date"
                value={dateTo}
                onChange={(e) => {
                  setDateTo(e.target.value);
                  setCurrentPage(1);
                }}
              />
            </div>
          </div>
          <CustomTableSortable
            columns={columns}
            rows={leadershipCouncils}
            totalCount={totalCount}
            currentPage={currentPage}
            pageSize={itemsPerPage}
            onPageChange={(page) => {
              setCurrentPage(page);
            }}
            isLoading={loading}
            sortField={uiSortField}
            sortOrder={sortOrder}
            onSortChange={(columnId, order) => {
              setUiSortField(columnId);
              setSortOrder(order);
              const apiField = sortFieldMap[columnId] || "createdAt";
              setSortField(apiField);
              setCurrentPage(1);
              // Fetch is driven by the useEffect (now depends on sortField/sortOrder) using fresh state.
            }}
          />
        </Card>
      </div>
    </>
  );
};

export default Customer;
